import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import Spinner from "../components/reusable/Spinner";
import APIS from "../constant/Endpoint";
import useGetHook from "../customHooks/useGetHook";
import usePostHook from "../customHooks/usePostHook";
import ServiceTypeIcon from "../Icons/ServiceTypeIcon";

const ConfigurationComponent = loadable(
  () => import("../components/Configuration")
);
const Configuration = () => {
  const { data, isLoading } = useGetHook({
    queryKey: ["configuration"],
    url: APIS.CONFIGUARTION,
    params: {},
  });
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["configuration"],
  });
  const handleEdit = async (values, setError) => {
    const url = APIS.CONFIGUARTION;
    const formData = { ...values };

    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };
  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <ServiceTypeIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Configuration
        </span>
      </div>
      <ConfigurationComponent
        data={data}
        handleEdit={handleEdit}
        isLoading={isPostLoading}
      />
    </>
  );
};

export default Configuration;
